
import Vue from "vue";
import { NewCompaniesApiFunc, setAccessToken } from "@/api";
import { Company } from "@/models";

import TheTemplate from "../components/TheNoSidebarTemplate.vue";
import BaseCloseButton from "@/components/BaseCloseButton.vue";
import CompanyEditor from "./components/CompanyEditor.vue";

export default Vue.extend({
  name: "CompanyCreateScreen",

  components: {
    TheTemplate,
    BaseCloseButton,
    CompanyEditor,
  },

  methods: {
    async createCompany(company: Company): Promise<void> {
      this.$setLoading(true);
      setAccessToken(this.$auth.accessToken);
      const { data, err } = await NewCompaniesApiFunc().adminCreateCompany(
        company
      );

      if (err != null) {
        this.$handleApiError(err, () => {
          this.createCompany(company);
        });
        this.$setLoading(false);
        return;
      }
      if (data?.id === undefined) {
        this.$handleApiError(undefined, () => {
          this.createCompany(company);
        });
        this.$setLoading(false);
        return;
      }
      this.$setLoading(false);
      this.$setChecked(true);
      this.$afterSuccessRequest(() => {
        this.$router.push({
          name: "admin-companies",
          params: {
            updated: "true",
          },
        });
      }, 2);
    },

    afterLeave(): void {
      this.$setChecked(false);
    },
  },
});
